import { useTranslation } from 'next-i18next';
import { FormState, FieldValues } from 'react-hook-form';

const Feedback = ({ formState, field }: { formState: FormState<FieldValues>, field: string }) => {
  const { t } = useTranslation();
  const { errors } = formState;

  return (
    <>
      {errors[field]?.type == 'required' && <div className="feedback feedback-ns feedback-danger">{t('feedback.required')}</div>}
      {errors[field]?.type == 'pattern' && <div className="feedback">{t('feedback.pattern')}</div>}
      {errors[field]?.type == 'minLength' && <div className="feedback feedback-ns">{t('feedback.minLength')}</div>}
      {errors[field]?.type == 'maxLength' && <div className="feedback feedback-ns">{t('feedback.maxLength')}</div>}
      {errors[field]?.type == 'notmatch' && <div className="feedback">{t('feedback.notmatch')}</div>}
    </>
  );
};

export default Feedback;
